/// <amd-module name="Build/Common/Commands/permissions/Command" />
import * as React from "react";

import { DefinitionReference } from "Build/Client/Contracts/Build";
import { IPermissionsProps } from "Build/Common/Commands/permissions/Command.types";

import { IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";
import { LegacyComponent } from "VSS/Legacy/Legacy";

class Permissions extends VssComponent<IPermissionsProps, {}> {
    public static componentType = "ciPermissionsComponent";

    constructor(props: IPermissionsProps) {
        super(props);
    }

    public render() {
        return (
            <LegacyComponent
                modules={["Build/Scripts/Components/DefinitionPermissionsDialog"]}
                wrappedType="ci-permissions-dialog"
                definition={this.props.definition}
                path={this.props.path}
            />
        );
    }
}

VssComponent.register(Permissions.componentType, Permissions);
